module.exports = __webpack_public_path__ + "assets/img/vtuber-3dscene.96be3a1f.png";